import CustomerEditPopup from "./CustomerEditPopup";

export default CustomerEditPopup;
